import { FileResponse } from "../api-client/api-client";

export function DownloadFromFileResponse(response: FileResponse) {

	// Extract content-type with a default as octet-stream
	let contentType = "application/octet-stream";
	if (response.headers)
		contentType = response.headers["content-type"];

	// Create blob from FileStream data
	const blob = new Blob([response.data], { type: contentType });

	// Create anchor element to prompt download popup
	const link = document.createElement("a");
	link.href = URL.createObjectURL(blob);
	link.download = response.fileName ? response.fileName : "UnknownFileName.xlsx";
	link.click();
	URL.revokeObjectURL(link.href);
}